<template>
  <div v-if="zoneItemConfig.groupId">
    <div
      :class="[
        'small-zone-part',
        'main',
        'service-with-searchbar',
        'division-fixed-top',
        'mall-list',
        'mall-list-style',
        itemIndex == 0 ? 'mall-list-border' : '',
        addClassName
      ]"
      :data-groupid="zoneItemConfig.groupId"
      :data-index="itemIndex + 1"
    >
      <div class="overflow-scrolling-box">
        <div class="list-top list-top-division">
          <!-- 头部 -->
          <div class="mall-bg" :style="zoneItemConfig.backPicStyle">
            <div
              v-if="!zoneItemConfig.backPicStyle"
              class="logo-info-bg"
              :style="zoneItemConfig.backPicStyle ? '' : zoneItemConfig.backgroundStyle"
            ></div>
            <!-- 标题 -->
            <div
              class="list-top-example"
              @click="
                goToZone({
                  zoneConfig: zoneItemConfig,
                  busItem: zoneItemConfig.busList[0],
                  pfStructure: `${pfStructure}_button`,
                  index: itemIndex + 1
                })
              "
            >
              <div class="game-head mall-title">
                <div class="game-info">
                  <span class="game-logo-box"><img v-lazy="zoneItemConfig.icon" class="game-logo" alt="" /></span>
                  <div>
                    <p class="game-name">{{ zoneItemConfig.name }}</p>
                    <subscribe-item
                      v-if="zoneItemConfig.subscribeId && !hideSubscribe"
                      show-type="smallZone"
                      :subscribe-id="zoneItemConfig.subscribeId"
                      :group-id="zoneItemConfig.groupId"
                      :change-subscribe-promp="changeSubscribePromp"
                      :pf-structure="pfStructure"
                    ></subscribe-item>
                  </div>
                </div>
                <div class="enter-btn-box">
                  <button class="enter-btn-zx" :style="{ backgroundColor: mainColor }">进入</button>
                </div>
              </div>
            </div>
            <!-- 广告位 -->
            <div v-if="zoneItemConfig.activityList && zoneItemConfig.activityList.length > 0" class="list-top-item mall-day-welfare">
              <div
                v-for="(activity, index) in zoneItemConfig.activityList"
                :key="activity.title"
                class="link-more"
                @click="
                  jumpToActivity({
                    ipZoneConfig: zoneItemConfig,
                    activity: activity,
                    pfStructure: pfStructure,
                    index: index + 1,
                    cacheDate: zoneListConfig
                  })
                "
              >
                <button
                  :class="{
                    'small-btn': true,
                    'small-btn--active': index % 2 === 1,
                    'small-btn--article': index % 2 === 0
                  }"
                >
                  {{ activity.tagName }}
                </button>
                <p class="link-title">{{ activity.title }}<i v-if="activity.link" class=""></i></p>
              </div>
            </div>
          </div>

          <!-- banner 泛娱乐banner为半渐变 -->
          <div
            v-if="zoneItemConfig.busList[0] && zoneItemConfig.busList[0].backgroundStyle && zoneItemConfig.busType == 2"
            class="list-top-item list-top-banner list-top-banner-style list-top-banner-info-mask"
          >
            <div
              class="new--moudle list-top-banner-info"
              :style="zoneItemConfig.busList[0].backgroundStyle"
              @click="
                goToZone({
                  zoneConfig: zoneItemConfig,
                  busItem: zoneItemConfig.busList[0],
                  pfStructure: `${pfStructure}_banner`,
                  index: itemIndex + 1
                })
              "
            >
              <h4 class="banner-info-title">{{ zoneItemConfig.busList[0].name }}</h4>
              <p class="banner-info-tips">{{ zoneItemConfig.busList[0].description || "&nbsp;" }}</p>
              <div class="banner-info-btn-box">
                <div class="banner-btn-left">
                  <button v-for="(tipsItem, index) in zoneItemConfig.busList[0].tagList" :key="index" class="btn-text">
                    {{ tipsItem }}
                  </button>
                </div>
                <button v-if="zoneItemConfig.busList[0].btnText" class="normal-btn pay-btn">
                  {{ zoneItemConfig.busList[0].btnText }}
                </button>
              </div>
            </div>
          </div>
          <!-- banner 游戏banner为图片卡片-->
          <div v-if="showGameImg" class="list-top-item list-top-banner list-top-banner-style list-top-item--loading">
            <div
              class="new--moudle list-top-banner-info"
              :style="zoneItemConfig.busList[0].backgroundStyle"
              style="background-size: cover"
              @click="
                jumpBannerActivity({
                  zoneConfig: zoneItemConfig,
                  busItem: zoneItemConfig.busList[0],
                  pfStructure: `${pfStructure}_banner`,
                  index: itemIndex + 1,
                  cacheDate: zoneListConfig
                })
              "
            ></div>
          </div>

          <!-- 推荐位 泛娱乐推荐位为swiper-->
          <div
            v-if="zoneItemConfig.hotRecommend && zoneItemConfig.hotRecommend.length && zoneItemConfig.busType == 2"
            class="list-top-item mall-props mall-props-swiper"
          >
            <div class="limit-active">
              <h3 class="limit-active-title">
                {{ zoneItemConfig.outerShelf.title }}
                <wx-open-launch-weapp-page
                  :report-user-config="
                    reportUserMoreConfig({
                      ipZoneConfig: zoneItemConfig,
                      pfStructure: pfStructure
                    })
                  "
                  type="more"
                >
                  <button
                    v-if="zoneItemConfig.outerShelf.link"
                    class="enter-btn"
                    @click="
                      jumpToOuterShelf({
                        ipZoneConfig: zoneItemConfig,
                        outerShelf: zoneItemConfig.outerShelf,
                        pfStructure: pfStructure,
                        cacheDate: zoneListConfig
                      })
                    "
                  >
                    更多
                  </button>
                </wx-open-launch-weapp-page>
              </h3>
              <div class="limit-active-wrap">
                <div class="swiper-container--active">
                  <template v-if="zoneItemConfig.mallType && zoneItemConfig.mallType == 'video'">
                    <div class="swiper-wrapper" style="padding-right: 0.16rem">
                      <template v-for="(hotRecommendItem, index) in zoneItemConfig.hotRecommend">
                        <div
                          v-if="index < 2"
                          :key="index"
                          class="swiper-slide"
                          :style="{
                            width: 'calc( 50% - 10px)',
                            marginRight: '10px'
                          }"
                          @click="
                            jumpToOuterShelfItem({
                              ipZoneConfig: zoneItemConfig,
                              jumpUrl: hotRecommendItem.link,
                              pfStructure: pfStructure,
                              index: index + 1,
                              cacheDate: zoneListConfig
                            })
                          "
                        >
                          <wx-open-launch-weapp-page
                            :report-user-config="
                              reportUserItemConfig({
                                ipZoneConfig: zoneItemConfig,
                                pfStructure: pfStructure,
                                index: index + 1
                              })
                            "
                            :goods-item="hotRecommendItem"
                          >
                            <div class="active-img-box">
                              <Img
                                :src="hotRecommendItem.image"
                                :max-height="((zoneItemConfig.outerShelf && zoneItemConfig.outerShelf.maxHeight) || '') + 'px'"
                                :min-height="((zoneItemConfig.outerShelf && zoneItemConfig.outerShelf.minHeight) || '') + 'px'"
                                class-name="active-img"
                                :error-img="imgHolder"
                              />
                            </div>
                            <!-- <p class="simple-module-item-tag simple-module-item-tag--new">上新</p> -->
                            <div class="active-detail">
                              <p class="active-name">{{ hotRecommendItem.title }}</p>
                              <p class="active-name-detail">{{ hotRecommendItem.subTitle }}</p>
                            </div>
                          </wx-open-launch-weapp-page>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <swiper ref="bannerSwiper" :options="swiperOption" class="swiper-wrapper" style="padding-right: 0.16rem">
                      <swiper-slide
                        v-for="(hotRecommendItem, index) in zoneItemConfig.hotRecommend"
                        :key="index"
                        class="swiper-slide"
                        :style="{
                          width: ((zoneItemConfig.outerShelf && zoneItemConfig.outerShelf.width) || 164) + 'px'
                        }"
                        @click.native="
                          jumpToOuterShelfItem({
                            ipZoneConfig: zoneItemConfig,
                            jumpUrl: hotRecommendItem.link,
                            pfStructure: pfStructure,
                            index: index + 1,
                            cacheDate: zoneListConfig
                          })
                        "
                      >
                        <div class="active-img-box">
                          <Img
                            :src="hotRecommendItem.image"
                            :max-height="((zoneItemConfig.outerShelf && zoneItemConfig.outerShelf.maxHeight) || '') + 'px'"
                            :min-height="((zoneItemConfig.outerShelf && zoneItemConfig.outerShelf.minHeight) || '') + 'px'"
                            class-name="active-img"
                            :error-img="imgHolder"
                          />
                        </div>
                        <!-- <p class="simple-module-item-tag simple-module-item-tag--new">上新</p> -->
                        <div class="active-detail">
                          <p class="active-name">{{ hotRecommendItem.title }}</p>
                          <p class="active-name-detail">{{ hotRecommendItem.subTitle }}</p>
                        </div>
                      </swiper-slide>
                    </swiper>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- 推荐位 游戏为4个道具固定位-->
          <div
            v-if="zoneItemConfig && zoneItemConfig.hotRecommend && zoneItemConfig.hotRecommend.length && zoneItemConfig.busType == 1"
            class="list-top-item mall-props"
          >
            <div class="limit-active book-module skin-module">
              <h3 class="limit-active-title">
                {{ zoneItemConfig.outerShelf.title }}
                <button
                  v-if="zoneItemConfig.outerShelf.link"
                  class="enter-btn"
                  @click="
                    goToZone({
                      zoneConfig: zoneItemConfig,
                      busItem: zoneItemConfig.busList[0],
                      pfStructure: `${pfStructure}_more`,
                      index: itemIndex + 1
                    })
                  "
                >
                  更多
                </button>
              </h3>
              <div class="limit-active-wrap limit-active-list">
                <div
                  v-for="(item, index) in zoneItemConfig && zoneItemConfig.hotRecommend && zoneItemConfig.hotRecommend.slice(0, 4)"
                  :key="index"
                  class="swiper-slide"
                  @click="
                    goDetail({
                      bizConfig: zoneItemConfig.busList[0],
                      item: item,
                      pfStructure: `${pfStructure}_position`,
                      index: index + 1,
                      cacheDate: zoneListConfig
                    })
                  "
                >
                  <div class="active-img-box">
                    <img v-lazy="item.icon" class="active-img" />
                  </div>
                  <p :class="['simple-module-item-tag', item.tagClass]">{{ item.activityTag }}</p>
                  <div class="active-detail">
                    <p class="active-name">{{ item.name }}</p>
                    <p class="active-name-detail active-name-detail-center">
                      <span
                        v-for="(tag, tagIndex) in item.tags"
                        :key="`tag${tagIndex}`"
                        :class="[
                          'mall-commodity-tag',
                          item.itemExtend && item.itemExtend.ItemType === '13' ? 'mall-commodity-tag--green' : 'mall-commodity-tag--blue'
                        ]"
                        >{{ tag }}</span
                      >
                      <span class="active-name-detail-center-txt">{{ item.remark }}</span>
                    </p>
                    <div class="active-cost">
                      <p class="active-cost--ticket">
                        <span class="active-cost--now" :style="{ color: mainColor }">
                          <i
                            class="icon-ticket"
                            :style="{
                              backgroundImage: gameCoinIcon ? 'url(' + gameCoinIcon + ')' : '',
                              display: item.showGameCoinPrice ? 'inline-block' : 'none'
                            }"
                          ></i>

                          {{ item.showGameCoinPrice ? "" : "￥" }}{{ item.showGameCoinPrice ? item.salePrice : item.saleCashRMBPrice }}
                        </span>
                        <span v-if="item.totalPrice" class="active-cost--old" :style="{ color: mainColor }"
                          >{{ item.showGameCoinPrice ? "" : "￥"
                          }}{{ item.showGameCoinPrice ? item.totalPrice : item.totalCashRMBPrice }}&nbsp;{{
                            item.showGameCoinPrice ? zoneItemConfig.unit : ""
                          }}</span
                        >
                      </p>
                      <!-- 由于一行放不下金币价，不再显示 -->
                      <p class="active-cost--gold" style="display: none">
                        <span v-if="item && item.saleInGameCoinPrice" class="active-cost--now">
                          <i class="icon-gold"></i>{{ item.saleInGameCoinPrice }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper"
import useZoneItem from "../../mixins/useZoneItem"
import SubscribeItem from "../Subscribe/SubscribeItem.vue"
import Img from "../Img.vue"
import { computed, reactive, toRefs } from "@vue/composition-api"
import wxOpenLaunchWeappPage from "@components/common/wxOpenLaunchWeapp"
import * as reportDict from "../../../constants/report-dictonary"
import * as jumpApi from "../../../business/jumpToapp"
import { checkTimeValid } from "@api/gameProps"

export default {
  name: "IpZoneItem",
  components: {
    swiper,
    swiperSlide,
    SubscribeItem,
    Img,
    wxOpenLaunchWeappPage
  },
  props: {
    zoneItemConfig: Object,
    pfStructure: String,
    itemIndex: Number,
    changeSubscribePromp: Function,
    addClassName: String,
    zoneListConfig: Array,
    hideSubscribe: { type: Boolean, default: false }
  },
  setup(props, { root }) {
    const { goDetail, goToZone, jumpToActivity, jumpBannerActivity, jumpToOuterShelf, jumpToOuterShelfItem, getMainColor } = useZoneItem(
      root
    )

    const data = reactive({
      subscribeGroups: computed(() => root.$store.state.subscribeGroups),
      imgHolder: computed(() => {
        // 腾讯视频推荐占位图
        if (props.zoneItemConfig.groupId == "20") {
          return "//puui.qpic.cn/vupload/0/common_pic_h.png/0"
        } else {
          return ""
        }
      })
    })

    const swiperOption = {
      loop: false,
      spaceBetween: 10,
      slidesPerView: "auto",
      freeMode: true
    }

    const gameCoinIcon = computed(() => {
      return (
        props.zoneItemConfig &&
        props.zoneItemConfig.busList &&
        props.zoneItemConfig.busList[0] &&
        props.zoneItemConfig.busList[0].gameCoinIcon
      )
    })

    const showGameImg = computed(() => {
      if (
        props?.zoneItemConfig?.busList &&
        props.zoneItemConfig.busList[0] &&
        props.zoneItemConfig.busList[0].image &&
        props.zoneItemConfig?.busType == 1
      ) {
        let bus = props.zoneItemConfig.busList[0]
        if ((bus.imageStart && bus.imageEnd && checkTimeValid(bus.imageStart, bus.imageEnd)) || (!bus.imageStart && !bus.imageEnd)) {
          return 1
        } else {
          return 0
        }
      } else {
        return 0
      }
    })

    const mainColor = computed(() => {
      return getMainColor()
    })
    const reportUserMoreConfig = ({ ipZoneConfig, pfStructure }) => {
      return {
        iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT_MORE}_${ipZoneConfig.groupId}`,
        resultInfo: {
          groupId: ipZoneConfig.groupId,
          target: jumpApi.appJumpLink({ type: "more" }),
          pfStructure
        }
      }
    }

    const reportUserItemConfig = ({ ipZoneConfig, pfStructure, index }) => {
      const { cid, vid } = ipZoneConfig?.hotRecommend[index - 1] || ""
      return {
        iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT}_${index}_${ipZoneConfig.groupId}`,
        resultInfo: {
          groupId: ipZoneConfig.groupId,
          index,
          pfStructure,
          target: jumpApi.appJumpLink({ cid, vid })
        }
      }
    }

    return {
      ...toRefs(data),
      swiperOption,
      gameCoinIcon,
      mainColor,
      showGameImg,
      goToZone,
      goDetail,
      jumpToActivity,
      jumpBannerActivity,
      jumpToOuterShelf,
      jumpToOuterShelfItem,
      reportUserMoreConfig,
      reportUserItemConfig
    }
  }
}
</script>
<style scoped>
.list-top-video.list-top .limit-active .limit-active-wrap .swiper-slide {
  margin-right: 0;
}
.list-top-video .limit-active .active-img {
  min-height: 0.7rem;
}
</style>
